var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.39 22.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.97,12.45H.93c-.51,0-.93,.42-.93,.93,0,.23,.09,.47,.26,.64,2.09,2.21,5.83,6.14,7.54,7.95,.23,.25,.56,.39,.9,.39s.67-.14,.9-.39c1.71-1.8,5.45-5.74,7.54-7.95,.17-.18,.26-.41,.26-.64,0-.52-.42-.93-.93-.93h-4.04V1.24c0-.66-.58-1.24-1.24-1.24H6.21c-.66,0-1.24,.59-1.24,1.24V12.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPoint);
export default __webpack_public_path__ + "static/media/drop-point.238a0d6eb123a40b63dddd2f07d29ac5.svg";
export { ForwardRef as ReactComponent };